export const urlTracks = "/api/tracks";

export const urlTopGenres = urlTracks + "/top/genres";
export const urlTopArtists = urlTracks + "/top/artists";
export const urlTopChimneys = urlTracks + "/top/chimneys";

export const getTopGenres = axios => axios.get(urlTopGenres);
export const getTopArtists = axios => axios.get(urlTopArtists);
export const getTopChimneys = axios => axios.get(urlTopChimneys);
